import React, { FunctionComponent } from 'react';
import {
  Avatar,
  Dialog,
  DialogContent,
  DialogTitle,
  Divider,
  IconButton,
  List,
  ListItem,
  ListItemAvatar,
  ListItemButton,
  ListItemText,
} from '@mui/material';
import { Close as CloseIcon } from '@mui/icons-material';

import { IUser } from '../../../../store/UserSlice';
import { getShortName } from '../../../../helper';

interface ViewUsersModalProps {
  open: boolean;
  users: IUser[];
  title: string;
  onClose: () => void;
}

const ViewUsersModal: FunctionComponent<ViewUsersModalProps> = ({
  open,
  users,
  title,
  onClose,
}) => {
  return (
    <Dialog
      maxWidth="sm"
      open={open}
      onClose={onClose}
      PaperProps={{
        sx: { borderRadius: '20px', maxWidth: '350px' },
      }}
    >
      <DialogTitle
        sx={{
          m: 0,
          p: { xs: '15px', sm: '30px' },
          color: '#000000',
          fontWeight: 600,
          fontSize: '16px',
        }}
      >
        {title}
      </DialogTitle>
      <IconButton
        aria-label="close"
        onClick={onClose}
        sx={{
          position: 'absolute',
          right: { xs: '7px', sm: '22px' },
          top: { xs: '7px', sm: '22px' },
        }}
      >
        <CloseIcon sx={{ color: '#000000' }} />
      </IconButton>
      <DialogContent
        sx={{ p: { xs: '0 15px 15px 15px', sm: '0 30px 30px 30px' } }}
      >
        <List disablePadding sx={{ p: 0 }}>
          {users.map((userItem, index) => {
            const isLast = users.length - 1 === index;

            return (
              <>
                <ListItem key={userItem._id} disablePadding>
                  <ListItemAvatar>
                    <Avatar src={userItem.avatar} />
                  </ListItemAvatar>
                  <ListItemText
                    primary={getShortName(
                      userItem.firstname,
                      userItem.lastname,
                      true
                    )}
                    secondary={userItem.country}
                  />
                </ListItem>
                {!isLast ? (
                  <Divider
                    key={`divider-${index}`}
                    sx={{ m: '5px 0', borderStyle: 'dashed' }}
                  />
                ) : null}
              </>
            );
          })}
        </List>
      </DialogContent>
    </Dialog>
  );
};

export default ViewUsersModal;
